import { render } from "./HospitalInfo.vue?vue&type=template&id=0b32d7d2&scoped=true"
import script from "./HospitalInfo.vue?vue&type=script&lang=js"
export * from "./HospitalInfo.vue?vue&type=script&lang=js"

import "./HospitalInfo.vue?vue&type=style&index=0&id=0b32d7d2&scoped=scoped&lang=scss"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b32d7d2"]])

export default __exports__